// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"191":"cfb5e199","413":"e606c14c","453":"0abe1307","923":"b03e4d43"}[chunkId] + ".chunk.js";
};